import React from 'react';
import PropTypes from 'prop-types';
import {isEmpty as _isEmpty} from 'lodash';
import {useQuery} from '@apollo/client';

import {GetCountrySubdivisionsForDropdown} from '@graphql/countrySubdivision/query';
import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import {showModal} from '@utils/modal';
import {renderCountryModalError} from '@modules/country/utils/utils';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';
import {SubdivisionsFilter} from '@utils/commonFilters/SubdivisionsFilter';

const CountryPostalCodesFilters = ({
    filters,
    loading,
    additionalFilterId,
    restoreFilterValues,
}) => {
    const {
        data: {
            country = { country_subdivisions: [] },
        } = {},
        error: errorFetchingCountrySubdivisionData,
        loading: isCountrySubdivisionDataLoading = true,
    } = useQuery(GetCountrySubdivisionsForDropdown,
        {
            variables: {
                countryId: additionalFilterId,
            },
        }
    );

    const BASE_FILTER_NAME = 'PostalCodesWithBlackoutZones',
        FILTER_NAME = BASE_FILTER_NAME + additionalFilterId,
        isLoading = loading || isCountrySubdivisionDataLoading;

    if (!_isEmpty(errorFetchingCountrySubdivisionData)) {
        showModal({
            isVisible: true,
            content: renderCountryModalError(errorFetchingCountrySubdivisionData.message),
        });
    }

    return (
        <div className='content__filters'>
            <SearchFilter
                loading={isLoading}
                filters={filters[FILTER_NAME]}
                restoreFilterValues={restoreFilterValues}
            />
            <SubdivisionsFilter
                subdivisions={country.country_subdivisions}
                loading={isLoading}
                filters={filters[FILTER_NAME]}
                restoreFilterValues={restoreFilterValues}
            />
        </div>
    );
};

CountryPostalCodesFilters.propTypes = {
    filters: PropTypes.shape({
        PostalCodesWithBlackoutZones: PropTypes.object.isRequired,
    }),
    loading: PropTypes.bool.isRequired,
    additionalFilterId: PropTypes.number.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};

export default FiltersWrapper(CountryPostalCodesFilters, {name: 'PostalCodesWithBlackoutZones', initialValues: {}});
